import MobileHeader from '../__header/mobileHeader';
const smoothScrollComplete = new CustomEvent('smoothScrollComplete');
const $ = jQuery.noConflict();

function scrollFunc(e) {
	e.preventDefault();

	const header = $('.main-header');
	const inPageNavigation = $('.block-in-page-navigation');
	const stickyClass = 'main-header--sticky';
	const target = $($(this).attr('href'));
	let stickyHeight = 0;

	if (header.hasClass(stickyClass) || inPageNavigation) {
		stickyHeight = header.outerHeight();
	}

	if (
		$(this).attr('href') === '#next' &&
		$(this).parents('section').next().length > 0
	) {
		// Smooth Scroll to next section
		$('html, body').animate(
			{
				scrollTop:
					$(this).parents('section').next().offset().top -
					stickyHeight,
			},
			600
		);
		MobileHeader.hideWrapper('.btn-hamburger', $('body'));
	} else if (target.length) {
		let scrollPosition = target.offset().top - stickyHeight;
		if ( inPageNavigation.length > 0 ) {
			scrollPosition -= inPageNavigation.height();
		}
		$('html, body').animate(
			{
				scrollTop: scrollPosition
			},
			600,
			'swing',
			function() {
				document.dispatchEvent(smoothScrollComplete);
			}
		);
		MobileHeader.hideWrapper('.btn-hamburger', $('body'));
	}
}

function scrollIdFunc(targetElement) {
	const scrolledPosition = targetElement.offset().top - $('.main-header').outerHeight() - 10;	
	$('html, body').animate(
		{
			scrollTop: scrolledPosition
		},
		600,
		'swing',
		function() {
			document.dispatchEvent(smoothScrollComplete);
		}
	);
	MobileHeader.hideWrapper('.btn-hamburger', $('body'));
}

function smoothScroll() {
	$('a[href^="#"]:not([href="#"])').on('click', scrollFunc);
	const currentHash = window.location.hash;
	if (currentHash) {
		const targetElement = $(currentHash);
		if (targetElement.length) {
			scrollIdFunc(targetElement);
		}
	}
}

export default smoothScroll;
